import { memo, useCallback } from 'react';

import { type NotificationClip as NotificationClipType } from '@air/api/types';

import { NotificationClip } from '~/components/AirNotifications/components/NotificationClip';
import {
  NOTIFICATION_CLIPS_MAX_COUNT,
  NotificationItemsThumbnails,
  type NotificationItemsThumbnailsProps,
  UI2026_NOTIFICATION_CLIPS_MAX_COUNT,
} from '~/components/AirNotifications/components/NotificationItemsThumbnails';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type NotificationClipsProps = {
  clips: NotificationClipType[];
  totalClips: number;
};

export const NotificationClips = memo(({ clips, totalClips }: NotificationClipsProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();
  const renderClip = useCallback<NotificationItemsThumbnailsProps<NotificationClipType>['renderItem']>(
    (clip) => <NotificationClip clip={clip} key={clip.id} />,
    [],
  );

  return (
    <NotificationItemsThumbnails
      items={clips}
      maxCount={ui2026 ? UI2026_NOTIFICATION_CLIPS_MAX_COUNT : NOTIFICATION_CLIPS_MAX_COUNT}
      overflowStyle={ui2026 ? 'chip' : 'overlay'}
      renderItem={renderClip}
      totalItemsCount={totalClips}
    />
  );
});

NotificationClips.displayName = 'NotificationClips';
